require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./tooltip"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./flexlayout", "./tooltip"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./tooltip")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./flexlayout"], root["./tooltip"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__16__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[27],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-grid{height:100%}.ba-common-grid__arrow-key-stepper:focus{outline:2px solid;outline-color:#a8c0f3;outline-color:hsla(var(--focus-h, 220.8), var(--focus-s, 75.7575757576%), var(--focus-l, 80.5882352941%), 1)}.ba-common-grid__bottom-right-grid:focus,.ba-common-grid__bottom-left-grid:focus,.ba-common-grid__top-left-grid:focus,.ba-common-grid__top-right-grid:focus{outline:none}.ba-common-grid__bottom-left-grid-cell{background-color:#fff;box-sizing:border-box}.ba-common-grid__bottom-left-grid-cell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-grid__bottom-left-grid-cell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-grid__bottom-left-grid-cell.is-fixedCellHorizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell{background-color:#eaeaea;background-color:hsla(var(--gray1-h, 0), var(--gray1-s, 0%), var(--gray1-l, 91.7647058824%), 1)}.ba-common-grid__top-left-grid-cell.cell-is-focused::after{content:\"\";position:absolute;border:2px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1);top:0;left:0;right:0;bottom:0;pointer-events:none}.ba-common-grid__top-left-grid-cell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell.is-fixedCellHorizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-grid .full-height{height:100%}.ba-common-grid .visually-hidden{top:0;left:-2px;width:1px;height:1px;position:absolute;overflow:hidden}", ""]);

// exports
exports.locals = {
	"gridClassName": "\"ba-common-grid\""
};

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(335);


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Grid = _interopRequireDefault(__webpack_require__(336));

exports.default = _Grid.default;
exports.Grid = _Grid.default;

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _button = _interopRequireDefault(__webpack_require__(12));

var _tooltip = _interopRequireDefault(__webpack_require__(16));

var _flexlayout = _interopRequireDefault(__webpack_require__(14));

var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(63));

var _reactVirtualized = __webpack_require__(337);

var _ArrowKeyStepper = _interopRequireDefault(__webpack_require__(338));

var _StringResource = _interopRequireDefault(__webpack_require__(339));

var _Grid = _interopRequireDefault(__webpack_require__(341));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  isEqual,
  uniqueId
} = _utils.lodash;

const gridClassName = _Grid.default.gridClassName.replace(/"/g, '');

const defaultGridAttributes = {
  ROW_OPTIONS_COLUMN_WIDTH: 40,
  ROW_HEIGHT: 40,
  COLUMN_WIDTH: 170,
  SCROLL_TO_COLUMN: -1,
  SCROLL_TO_ROW: -1,
  MAX_COLUMN_WIDTH: 400,
  OVERSCAN_COLUMN_COUNT: 10,
  OVERSCAN_ROW_COUNT: 20
};

function isAutoMeasurePropsValid({
  autoMeasureColumnWidth,
  autoMeasureRowHeight,
  columnWidth,
  rowHeight
}, propName, componentName) {
  if (propName === 'autoMeasureColumnWidth' && autoMeasureColumnWidth) {
    if (!rowHeight) {
      return console.warn( // eslint-disable-line
      "If 'autoMeasureColumnWidth' is passed, it must be accompanied with the measurement prop 'rowHeight', or default will be used.");
    }

    if (columnWidth) {
      return new Error(`Invalid prop '${propName}' passed to '${componentName}'. If 'autoMeasureColumnWidth' is passed, then you cannot pass 'columnWidth'.`);
    }
  }

  if (propName === 'autoMeasureRowHeight' && autoMeasureRowHeight) {
    if (!columnWidth) {
      return console.warn( // eslint-disable-line
      "If 'autoMeasureRowHeight' is passed, it must be accompanied with the measurement prop 'columnWidth', or default will be used.");
    }

    if (rowHeight) {
      return new Error(`Invalid prop '${propName}' passed to '${componentName}'. If 'autoMeasureRowHeight' is passed, then you cannot pass 'rowHeight'.`);
    }
  }

  return null;
}

class Grid extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "state", {
      scrollToAlignment: 'auto'
    });
    (0, _defineProperty2.default)(this, "setRowScrollIndex", ({
      index
    }) => {
      this.setState({
        focusedCell: {
          columnIndex: 0,
          rowIndex: index + this._getFixedRows()
        }
      });
    });
    (0, _defineProperty2.default)(this, "setColumnScrollIndex", ({
      index
    }) => {
      this.setState({
        focusedCell: {
          columnIndex: index + this._getFixedColumns(),
          rowIndex: 0
        }
      });
    });
    (0, _defineProperty2.default)(this, "_multiGridRef", null);
    (0, _defineProperty2.default)(this, "_multiGridKey", uniqueId());
    (0, _defineProperty2.default)(this, "invalidateCellSizeAfterRender", ({
      rowIndex = 0,
      columnIndex = 0
    } = {}) => {
      this._multiGridRef && this._multiGridRef.invalidateCellSizeAfterRender && this._multiGridRef.invalidateCellSizeAfterRender({
        rowIndex,
        columnIndex
      });
    });
    (0, _defineProperty2.default)(this, "recomputeGridSize", ({
      rowIndex = 0,
      columnIndex = 0
    } = {}) => {
      this._multiGridRef && this._multiGridRef.recomputeGridSize && this._multiGridRef.recomputeGridSize({
        rowIndex,
        columnIndex
      });
    });
    (0, _defineProperty2.default)(this, "_initializeCellMeasureCache", () => {
      if (this._shouldAutoMeasureColumnWidth()) {
        this._cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
          minHeight: defaultGridAttributes.ROW_HEIGHT,
          minWidth: defaultGridAttributes.COLUMN_WIDTH,
          fixedHeight: true
        });
      } else if (this._shouldAutoMeasureRowHeight()) {
        this._cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
          minHeight: defaultGridAttributes.ROW_HEIGHT,
          minWidth: defaultGridAttributes.COLUMN_WIDTH,
          fixedWidth: true
        });
      }
    });
    (0, _defineProperty2.default)(this, "_resetScrollToIndices", () => {
      this.setState({
        focusedCell: {
          columnIndex: defaultGridAttributes.SCROLL_TO_COLUMN,
          rowIndex: defaultGridAttributes.SCROLL_TO_ROW
        }
      });
    });
    (0, _defineProperty2.default)(this, "_shouldAutoMeasureColumnWidth", (props = this.props) => !!(props.autoMeasureColumnWidth && !props.columnWidth));
    (0, _defineProperty2.default)(this, "_shouldAutoMeasureRowHeight", (props = this.props) => !!(props.autoMeasureRowHeight && !props.rowHeight));
    (0, _defineProperty2.default)(this, "_onSectionRendered", ({
      rowStopIndex,
      columnStopIndex,
      rowStartIndex,
      columnStartIndex
    }) => {
      const {
        getMoreData,
        onAfterGridUpdate
      } = this.props;
      onAfterGridUpdate && onAfterGridUpdate({
        rowEnd: rowStopIndex,
        colEnd: columnStopIndex,
        rowStart: rowStartIndex,
        colStart: columnStartIndex
      });
      const rowOffset = this._getRowCount() - this._getFixedRows() - 1;

      if (rowStopIndex === rowOffset) {
        getMoreData && getMoreData();
      }
    });
    (0, _defineProperty2.default)(this, "_getColumnCount", (props = this.props) => props.numColumns + this._getFixedColumns(props));
    (0, _defineProperty2.default)(this, "_getRowCount", (props = this.props) => props.numRows + this._getFixedRows(props));
    (0, _defineProperty2.default)(this, "_getFixedColumns", (props = this.props) => {
      const fixedColumns = (props.fixedColumns || 0) + (props.useRowOptionsColumn ? 1 : 0);
      return fixedColumns > 0 ? fixedColumns : 0;
    });
    (0, _defineProperty2.default)(this, "_getFixedRows", (props = this.props) => props.fixedRows);
    (0, _defineProperty2.default)(this, "_getRowOverscan", (props = this.props) => {
      const overscan = props.overscanRowCount;
      return overscan === 0 || overscan > 0 ? overscan : defaultGridAttributes.OVERSCAN_ROW_COUNT;
    });
    (0, _defineProperty2.default)(this, "_getColumnOverscan", (props = this.props) => {
      const overscan = props.overscanColumnCount;
      return overscan === 0 || overscan > 0 ? overscan : defaultGridAttributes.OVERSCAN_COLUMN_COUNT;
    });
    (0, _defineProperty2.default)(this, "_isFixedRowScrollable", () => this.props.numRows === 0 && this.props.fixedRows > 0);
    (0, _defineProperty2.default)(this, "_bidiStyles", () => {
      if (this.props.dir === 'rtl') {
        // HACK: react-virtualized (RV) doesn't support RTL, we perform a rotational transform
        // to get around this issue. Note that RV explicitly sets direction to ltr as a
        // band aid solution since rtl breaks the grid.
        // Refer to https://github.com/bvaughn/react-virtualized/issues/454
        return {
          transform: 'rotateY(180deg)',
          WebkitFontSmoothing: 'antialiased',
          justifyContent: 'flex-end'
        };
      }

      return {
        justifyContent: 'flex-start'
      };
    });
    (0, _defineProperty2.default)(this, "_constrainColumnWidth", width => Math.min(width, this.props.maxColumnWidth));
    (0, _defineProperty2.default)(this, "_cellRenderer", ({
      columnIndex,
      key,
      rowIndex,
      style = {},
      parent
    }) => {
      const {
        focusedCell
      } = this.state;
      const focusedClassname = {
        'cell-is-focused': focusedCell.columnIndex === columnIndex && focusedCell.rowIndex === rowIndex
      };
      const {
        useRowOptionsColumn,
        onFixedCornerCellMenu
      } = this.props;

      const fixedColumns = this._getFixedColumns();

      const fixedRows = this._getFixedRows(); // HACK: When using CellMeasurer with MultiGrid there is a bug. There are two cases to consider:
      // 1. fixedHeight: true => width will auto measure. Produces correct behaviour.
      // 2. fixedWidth: true => height will auto measure. Incorrect behaviour.
      // It seems that when CellMeasurer._getCellMeasurements runs, node.style.width is auto which
      // means height is being measured before the before the width is applied. To remedy this,
      // we force set the dimension styles when it's auto.
      // Refer to https://github.com/bvaughn/react-virtualized/issues/1354


      if (this._shouldAutoMeasureRowHeight()) {
        if (style.width === 'auto') {
          const {
            columnWidth
          } = this._getColumnWidthProps();

          style.width = columnWidth({
            index: columnIndex
          });
        } else {
          style.width = this._constrainColumnWidth(style.width);
        }

        style.whiteSpace = 'normal';
      }

      if (this._shouldAutoMeasureColumnWidth()) {
        style.whiteSpace = 'nowrap';
      }

      const cellBaseProps = {
        cellOnClick: () => this._selectCell({
          scrollToColumn: columnIndex,
          scrollToRow: rowIndex
        }),
        className: focusedClassname,
        key,
        style: { ...style,
          ...this._bidiStyles()
        }
      };
      let cell = null;

      if (useRowOptionsColumn && columnIndex === 0) {
        if (rowIndex === 0 && onFixedCornerCellMenu) {
          cell = this._fixedCornerCellRenderer({ ...cellBaseProps,
            rowIndex
          });
        } else {
          cell = this._fixedColumnCellRenderer({ ...cellBaseProps
          });
        }
      } else if (columnIndex < fixedColumns && rowIndex < fixedRows) {
        cell = this._fixedCornerCellRenderer({ ...cellBaseProps,
          columnIndex,
          rowIndex
        });
      } else if (columnIndex < fixedColumns) {
        cell = this._fixedColumnCellRenderer({ ...cellBaseProps,
          columnIndex,
          rowIndex: rowIndex - fixedRows
        });
      } else if (rowIndex < fixedRows) {
        cell = this._fixedRowCellRenderer({ ...cellBaseProps,
          columnIndex: columnIndex - fixedColumns,
          rowIndex
        });
      } else {
        cell = this._cellRendererMain({ ...cellBaseProps,
          columnIndex: columnIndex - fixedColumns,
          rowIndex: rowIndex - fixedRows
        });
      }

      if (this._shouldAutoMeasureColumnWidth() || this._shouldAutoMeasureRowHeight()) {
        return /*#__PURE__*/_react.default.createElement(_reactVirtualized.CellMeasurer, {
          key: key,
          parent: parent,
          cache: this._cellMeasurerCache,
          columnIndex: columnIndex,
          rowIndex: rowIndex
        }, cell);
      }

      return cell;
    });
    (0, _defineProperty2.default)(this, "_hasClickableHeaderMenu", row => {
      const fixedRows = this._getFixedRows();

      return row === 0 && fixedRows > 0 && this.props.onFixedRowCellMenu;
    });
    (0, _defineProperty2.default)(this, "_onCornerMenuClicked", e => {
      e.preventDefault();
      e.stopPropagation();
      let {
        clientX,
        clientY
      } = e;

      if (clientX === 0 && clientY === 0) {
        const {
          x,
          y
        } = e.currentTarget.getBoundingClientRect();
        clientX = x;
        clientY = y;
      }

      this.props.onFixedCornerCellMenu && this.props.onFixedCornerCellMenu(clientX, clientY, 0, 0);
    });
    (0, _defineProperty2.default)(this, "_fixedCornerCellRenderer", ({
      className,
      columnIndex,
      key,
      rowIndex,
      style,
      cellOnClick
    }) => {
      const {
        fixedCornerCellMenuIcon,
        rowOptionsColumnText,
        dir,
        useRowOptionsColumn,
        fixedCellVerticalBorder,
        fixedCellHorizontalBorder
      } = this.props;
      let borderClassName = fixedCellVerticalBorder && (dir === 'rtl' ? {
        'rtl-border': true
      } : {
        'ltr-border': true
      });
      borderClassName = (0, _utils.classnames)(borderClassName, {
        fixedCellHorizontalBorder
      });

      if (useRowOptionsColumn) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _utils.classnames)(`${gridClassName}__top-left-grid-cell`, className, borderClassName),
          key: key,
          style: style,
          onKeyDown: e => this._onKeyDown(e, cellOnClick),
          onClick: cellOnClick
        }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
          justifyContent: "center",
          height: "100%",
          direction: "column"
        }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          title: rowOptionsColumnText
        }, /*#__PURE__*/_react.default.createElement(_button.default, {
          fullWidth: true,
          onClick: this._onCornerMenuClicked,
          onContextMenu: this._onCornerMenuClicked,
          tabIndex: 0,
          variant: "inline",
          "data-tid": "ba-common-grid__menu-button",
          icon: /*#__PURE__*/_react.default.createElement(_svgicon.default, {
            pad: true,
            iconId: fixedCornerCellMenuIcon ? fixedCornerCellMenuIcon.id : _overflowMenuVertical_.default.id,
            size: "small"
          })
        }))));
      }

      const {
        fixedCornerCellRenderer
      } = this.props;
      const gridCellProps = {
        className: (0, _utils.classnames)('top-left-grid-cell', className),
        style,
        key,
        onClick: cellOnClick,
        dir
      };
      return fixedCornerCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", (e, clickHandler) => {
      if (e.keyCode === 32 || e.keyCode === 13) {
        clickHandler && clickHandler();
      }
    });
    (0, _defineProperty2.default)(this, "_fixedColumnCellRenderer", ({
      className,
      columnIndex,
      key,
      rowIndex,
      style,
      cellOnClick
    }) => {
      const {
        fixedCellVerticalBorder,
        fixedCellHorizontalBorder,
        useRowOptionsColumn,
        dir
      } = this.props;
      let borderClassName = fixedCellVerticalBorder && (dir === 'rtl' ? {
        'rtl-border': true
      } : {
        'ltr-border': true
      });
      borderClassName = (0, _utils.classnames)(borderClassName, {
        fixedCellHorizontalBorder
      });

      if (useRowOptionsColumn) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _utils.classnames)(`${gridClassName}__bottom-left-grid-cell`, className, borderClassName),
          key: key,
          style: style,
          onKeyDown: e => this._onKeyDown(e, cellOnClick),
          onClick: cellOnClick
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH
          }
        }));
      }

      const {
        fixedColumnCellRenderer
      } = this.props;
      const gridCellProps = {
        className: (0, _utils.classnames)('bottom-left-grid-cell', className),
        style,
        key,
        onClick: cellOnClick,
        dir
      };
      return fixedColumnCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2.default)(this, "_cellRendererMain", ({
      className,
      columnIndex,
      key,
      rowIndex,
      style,
      cellOnClick
    }) => {
      const {
        selectedColumns,
        dataCellRenderer,
        dir
      } = this.props;
      const gridCellProps = {
        className: (0, _utils.classnames)('bottom-right-grid-cell', className, {
          'cell-is-selected': selectedColumns.includes(columnIndex)
        }),
        style,
        key,
        onClick: cellOnClick,
        dir
      };
      return dataCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2.default)(this, "_fixedRowCellOnMenu", (rowIndex, columnIndex, cellOnClick) => e => {
      if (this._hasClickableHeaderMenu(rowIndex)) {
        e.preventDefault();
        this.props.onFixedRowCellMenu(e.clientX, e.clientY, rowIndex, columnIndex);
      }

      cellOnClick();
    });
    (0, _defineProperty2.default)(this, "_fixedRowCellRenderer", ({
      className,
      columnIndex,
      key,
      rowIndex,
      style,
      cellOnClick
    }) => {
      const {
        selectedColumns,
        fixedRowCellRenderer,
        dir
      } = this.props;
      const gridCellProps = {
        className: (0, _utils.classnames)(className, {
          'top-right-grid-cell header-cell': rowIndex === 0,
          'bottom-right-grid-cell': rowIndex > 0,
          'cell-is-selected': selectedColumns.includes(columnIndex)
        }),
        style,
        key,
        onClick: this._fixedRowCellOnMenu(rowIndex, columnIndex, cellOnClick),
        onContextMenu: this._fixedRowCellOnMenu(rowIndex, columnIndex, cellOnClick),
        dir
      };
      return fixedRowCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2.default)(this, "_selectCell", ({
      scrollToColumn,
      scrollToRow
    }) => {
      const {
        onCellFocus,
        focusedCell
      } = this.props;

      if (!focusedCell) {
        this.setState({
          focusedCell: {
            columnIndex: scrollToColumn,
            rowIndex: scrollToRow
          }
        });
      }

      onCellFocus && onCellFocus({
        columnIndex: scrollToColumn,
        rowIndex: scrollToRow
      });
    });
    (0, _defineProperty2.default)(this, "_getFocusedCellContent", () => {
      const {
        focusedCell: {
          rowIndex,
          columnIndex
        }
      } = this.state; // Set focused contents when within grid boundaries

      return rowIndex >= 0 && columnIndex >= 0 ? this._cellRenderer({
        columnIndex,
        rowIndex
      }) : null;
    });
    (0, _defineProperty2.default)(this, "_makeConstrained", fn => ref => this._constrainColumnWidth(fn(ref)));
    (0, _defineProperty2.default)(this, "_getColumnWidthProps", () => {
      const {
        columnWidth,
        useRowOptionsColumn
      } = this.props;
      let columnWidthProp = null;

      if (this._shouldAutoMeasureColumnWidth()) {
        columnWidthProp = ref => {
          if (useRowOptionsColumn && ref.index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return this._cellMeasurerCache.columnWidth(ref);
        };
      } else if (typeof columnWidth === 'function') {
        columnWidthProp = ({
          index
        }) => {
          if (useRowOptionsColumn && index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return columnWidth(index);
        };
      } else {
        columnWidthProp = ({
          index
        }) => {
          if (useRowOptionsColumn && index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return defaultGridAttributes.COLUMN_WIDTH;
        };
      }

      return {
        columnWidth: this._shouldAutoMeasureColumnWidth() ? columnWidthProp : this._makeConstrained(columnWidthProp)
      };
    });
    (0, _defineProperty2.default)(this, "_getRowHeightProps", () => {
      const {
        rowHeight
      } = this.props;

      if (this._shouldAutoMeasureRowHeight()) {
        return {
          rowHeight: this._cellMeasurerCache.rowHeight
        };
      } else if (typeof rowHeight === 'function') {
        return {
          rowHeight: ({
            index
          }) => rowHeight(index)
        };
      }

      return {
        rowHeight: () => defaultGridAttributes.ROW_HEIGHT
      };
    });
    (0, _defineProperty2.default)(this, "_getMeasurementCacheProps", () => {
      if (this._shouldAutoMeasureColumnWidth() || this._shouldAutoMeasureRowHeight()) {
        return {
          deferredMeasurementCache: this._cellMeasurerCache
        };
      }

      return {};
    });

    this._initializeCellMeasureCache();
  }

  componentWillMount() {
    const {
      focusedCell
    } = this.props;
    const defaultFocusedCell = {
      columnIndex: defaultGridAttributes.SCROLL_TO_COLUMN,
      rowIndex: defaultGridAttributes.SCROLL_TO_ROW
    };
    this.setState({
      focusedCell: focusedCell || defaultFocusedCell
    });
  }

  componentWillReceiveProps(nextProps) {
    // Reset scroll indices when there are new/empty selected columns
    if (!isEqual(nextProps.selectedColumns, this.props.selectedColumns)) {
      this._resetScrollToIndices();
    }

    const didAutoMeasureChange = this._shouldAutoMeasureColumnWidth(nextProps) !== this._shouldAutoMeasureColumnWidth() || this._shouldAutoMeasureRowHeight(nextProps) !== this._shouldAutoMeasureRowHeight(); // The grid doesn't properly update the cache, when we switch auto measurement props.
    // Therefore, we manually create new caches per auto measurement props change.


    if (didAutoMeasureChange) {
      this._initializeCellMeasureCache();
    } // The multigrid doesn't properly update these values change (deferredMeasurementCache, fixedColumnCount, fixedRowCount)
    // Therefore, we'll need to force a remount of the component.


    if (didAutoMeasureChange || this._getFixedRows(nextProps) !== this._getFixedRows() || this._getColumnCount(nextProps) !== this._getColumnCount()) {
      this._multiGridKey = uniqueId();
    }

    const {
      focusedCell
    } = nextProps;

    if (focusedCell) {
      this.setState({
        focusedCell
      });
    }
  }

  forceUpdateGrids() {
    this._multiGridRef && this._multiGridRef.forceUpdateGrids && this._multiGridRef.forceUpdateGrids();
  }

  render() {
    const adjustedColumnCount = this._getColumnCount();

    const adjustedRowCount = this._getRowCount();

    const adjustedFixedColumns = this._getFixedColumns();

    const adjustedFixedRows = this._getFixedRows();

    const isFixedRowScrollable = this._isFixedRowScrollable();

    const {
      focusedCell,
      scrollToAlignment
    } = this.state;
    const {
      onFixedCornerCellMenu,
      onFixedRowCellMenu,
      style,
      className
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_ArrowKeyStepper.default, {
      className: `${gridClassName} full-height ${className}`,
      columnCount: adjustedColumnCount,
      onScrollToChange: this._selectCell,
      mode: "cells",
      rowCount: adjustedRowCount,
      scrollToColumn: focusedCell.columnIndex,
      scrollToRow: focusedCell.rowIndex,
      fixedColumns: adjustedFixedColumns,
      fixedRows: adjustedFixedRows,
      onFixedCornerCellMenu: onFixedCornerCellMenu,
      onFixedRowCellMenu: onFixedRowCellMenu,
      style: style
    }, ({
      scrollToColumn,
      scrollToRow,
      registerChild
    }) => /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__arrow-key-stepper full-height`,
      tabIndex: 0,
      onBlur: () => this._resetScrollToIndices()
    }, /*#__PURE__*/_react.default.createElement("div", {
      key: `${scrollToColumn}_${scrollToRow}`,
      "aria-live": "polite",
      className: `${gridClassName} visually-hidden`
    }, this._getFocusedCellContent()), /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, null, ({
      width,
      height
    }) => /*#__PURE__*/_react.default.createElement(_reactVirtualized.MultiGrid, (0, _extends2.default)({}, this._getMeasurementCacheProps(), this._getColumnWidthProps(), this._getRowHeightProps(), {
      scrollToAlignment: scrollToAlignment,
      scrollToColumn: scrollToColumn,
      scrollToRow: scrollToRow,
      cellRenderer: this._cellRenderer,
      columnCount: adjustedColumnCount,
      fixedRowCount: adjustedFixedRows,
      fixedColumnCount: adjustedFixedColumns,
      rowCount: adjustedRowCount,
      height: height - 1,
      width: width - 1,
      overscanColumnCount: this._getColumnOverscan(),
      overscanRowCount: this._getRowOverscan(),
      onSectionRendered: this._onSectionRendered,
      enableFixedRowScroll: isFixedRowScrollable,
      hideTopRightGridScrollbar: isFixedRowScrollable,
      ref: node => {
        registerChild(node);
        this._multiGridRef = node;
      },
      classNameBottomLeftGrid: `${gridClassName}__bottom-left-grid`,
      classNameBottomRightGrid: `${gridClassName}__bottom-right-grid`,
      classNameTopLeftGrid: `${gridClassName}__top-left-grid`,
      classNameTopRightGrid: `${gridClassName}__top-right-grid`,
      style: this._bidiStyles(),
      tabIndex: -1,
      key: this._multiGridKey
    })))));
  }

}

exports.default = Grid;
(0, _defineProperty2.default)(Grid, "propTypes", {
  /** Let the grid auto measure a cell's width only, cannot be used with columnWidth. */
  autoMeasureColumnWidth: _propTypes.default.bool && isAutoMeasurePropsValid,

  /** Let the grid auto measure a cell's height only, cannot be used with rowHeight. */
  autoMeasureRowHeight: _propTypes.default.bool && isAutoMeasurePropsValid,

  /** Class attributes applied to the grid container */
  className: _propTypes.default.string,

  /** Callback function that returns the width of a column given its index, defaults to 170. */
  columnWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),

  /** Callback function that returns cell element for given row and column index for the data part of grid */
  dataCellRenderer: _propTypes.default.func.isRequired,

  /** String for bidi support */
  dir: _propTypes.default.oneOf(['ltr', 'rtl']),

  /** Number of fixed columns in grid, defaults to 0 */
  fixedColumns: _propTypes.default.number,

  /** ID of svg icon to be used in row options menu cell (temporary hack by design) */
  fixedCornerCellMenuIcon: _propTypes.default.object,

  /** Callback function that returns cell element for given row and column index for fixed column part of grid */
  fixedColumnCellRenderer: _propTypes.default.func,

  /** Callback function that returns cell element for given row and column index for fixed corner part of grid */
  fixedCornerCellRenderer: _propTypes.default.func,

  /** Callback function that returns cell element for given row and column index for fixed row part of grid */
  fixedRowCellRenderer: _propTypes.default.func,

  /** Number of fixed row headers in grid, defaults to 0 */
  fixedRows: _propTypes.default.number,

  /** Indices of the focused cell */
  focusedCell: _propTypes.default.object,

  /** Callback that is called when the bottom of the grid is reached. */
  getMoreData: _propTypes.default.func,

  /** Maximum column width value */
  maxColumnWidth: _propTypes.default.number,

  /** Number of columns in grid */
  numColumns: _propTypes.default.number.isRequired,

  /** Number of rows in grid */
  numRows: _propTypes.default.number.isRequired,

  /** Callback function that is called when a grid has updated. It passes in a range object with the visible rows and columns */
  onAfterGridUpdate: _propTypes.default.func,

  /** Callback when cell focus is changed */
  onCellFocus: _propTypes.default.func,

  /** Callback when the corner grid menu is clicked */
  onFixedCornerCellMenu: _propTypes.default.func,

  /** Callback when fixed cell header is clicked in grid. useRowOptionsColumn is required */
  onFixedRowCellMenu: _propTypes.default.func,

  /** Count of overscan column */
  overscanColumnCount: _propTypes.default.number,

  /** Count of overscan row */
  overscanRowCount: _propTypes.default.number,

  /** Callback function that returns the height of a row given its index, defaults to 40. */
  rowHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),

  /** Text that will be shown in the corner cell menu tooltip */
  rowOptionsColumnText: _propTypes.default.string,

  /** Array of number of columns to highlight as selected */
  selectedColumns: _propTypes.default.array,

  /** Styles to be applied to the grid container */
  style: _propTypes.default.object,

  /** Enable row options column */
  useRowOptionsColumn: _propTypes.default.bool,

  /** Toggle the vertical border around the cell of the fixed cells */
  fixedCellVerticalBorder: _propTypes.default.bool,

  /** Toggle the horizontal border around the cell of the fixed cell */
  fixedCellHorizontalBorder: _propTypes.default.bool
});
(0, _defineProperty2.default)(Grid, "defaultProps", {
  selectedColumns: [],
  fixedRows: 0,
  fixedColumns: 0,
  getMoreData: () => null,
  onAfterGridUpdate: () => null,
  autoMeasureColumnWidth: false,
  autoMeasureRowHeight: false,
  dataCellRenderer: () => null,
  fixedColumnCellRenderer: () => null,
  fixedCornerCellRenderer: () => null,
  fixedRowCellRenderer: () => null,
  onFixedRowCellMenu: () => null,
  rowOptionsColumnText: _StringResource.default.get('changeGridSettings'),
  dir: 'ltr',
  className: '',
  style: {},
  maxColumnWidth: defaultGridAttributes.MAX_COLUMN_WIDTH,
  fixedCellVerticalBorder: true,
  fixedCellHorizontalBorder: true
});

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports = require("react-virtualized");

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;
/* eslint react/no-unused-state: 'off' */

/**
 * Forked from react-virtualized project: https://github.com/bvaughn/react-virtualized
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

class ArrowKeyStepper extends _react.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_columnStartIndex", 0);
    (0, _defineProperty2.default)(this, "_columnStopIndex", 0);
    (0, _defineProperty2.default)(this, "_rowStartIndex", 0);
    (0, _defineProperty2.default)(this, "_rowStopIndex", 0);
    (0, _defineProperty2.default)(this, "_registeredChild", null);
    (0, _defineProperty2.default)(this, "_onKeyDown", event => {
      const {
        columnCount,
        rowCount,
        onFixedCornerCellMenu,
        onFixedRowCellMenu,
        fixedRows,
        fixedColumns
      } = this.props; // Don't do anything if there's no data
      // Also considered the case where the row count is adjusted

      if (rowCount === fixedRows || rowCount === 0) return;

      const {
        scrollToColumn: scrollToColumnPrevious,
        scrollToRow: scrollToRowPrevious
      } = this._getScrollState();

      let {
        scrollToColumn,
        scrollToRow
      } = this._getScrollState();

      const {
        LEFT,
        RIGHT,
        UP,
        DOWN,
        F10,
        END,
        HOME
      } = keyNames;
      const keyName = getKeyName(event);

      switch (keyName) {
        case DOWN:
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
          break;

        case LEFT:
          scrollToColumn = Math.max(scrollToColumn - 1, 0);
          break;

        case RIGHT:
          scrollToColumn = Math.min(scrollToColumn + 1, columnCount - 1);
          break;

        case UP:
          scrollToRow = Math.max(scrollToRow - 1, 0);
          break;

        case HOME:
          scrollToRow = fixedRows;
          break;

        case END:
          scrollToRow = rowCount - 1;
          break;

        default:
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        if (scrollToColumnPrevious < 0 || scrollToRowPrevious < 0) {
          // If out of bounds and key down event then set the focused cell to 0,0
          this._updateScrollState({
            scrollToColumn: 0,
            scrollToRow: 0
          });
        } else {
          this._updateScrollState({
            scrollToColumn,
            scrollToRow
          });
        }
      } else if (keyName === F10) {
        if (event.shiftKey) {
          event.preventDefault();

          const {
            x,
            y
          } = _reactDom.default.findDOMNode(this._registeredChild).getBoundingClientRect();

          if (scrollToRow < fixedRows && scrollToColumn < fixedColumns) {
            // If in the corner grid
            onFixedCornerCellMenu && onFixedCornerCellMenu(x, y, 0, 0);
          } else if (scrollToRow === 0 && scrollToColumn >= fixedColumns && onFixedRowCellMenu) {
            // If in row header
            // eslint-disable-next-line no-underscore-dangle
            const gridCellOffset = this._registeredChild._bottomRightGrid.getOffsetForCell({
              alignment: 'start',
              columnIndex: scrollToColumn,
              rowIndex: scrollToRow
            }); // eslint-disable-next-line no-underscore-dangle


            const scrollContainer = _reactDom.default.findDOMNode(this._registeredChild._bottomRightGrid // eslint-disable-line no-underscore-dangle
            );

            onFixedRowCellMenu && onFixedRowCellMenu(gridCellOffset.scrollLeft + x - scrollContainer.scrollLeft, y, scrollToRow, scrollToColumn - fixedColumns);
          }
        }
      }
    });
    (0, _defineProperty2.default)(this, "_onSectionRendered", ({
      columnStartIndex,
      columnStopIndex,
      rowStartIndex,
      rowStopIndex
    }) => {
      this._columnStartIndex = columnStartIndex;
      this._columnStopIndex = columnStopIndex;
      this._rowStartIndex = rowStartIndex;
      this._rowStopIndex = rowStopIndex;
    });
    (0, _defineProperty2.default)(this, "_getScrollState", () => this.props.isControlled ? this.props : this.state);
    (0, _defineProperty2.default)(this, "_updateScrollState", ({
      scrollToColumn,
      scrollToRow
    }) => {
      const {
        isControlled,
        onScrollToChange
      } = this.props;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn,
          scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn,
          scrollToRow
        });
      }
    });
    (0, _defineProperty2.default)(this, "_registerChild", child => {
      this._registeredChild = child;
    });
    this.state = {
      scrollToColumn: props.scrollToColumn,
      scrollToRow: props.scrollToRow
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isControlled) {
      return;
    }

    const {
      scrollToColumn,
      scrollToRow
    } = nextProps;
    const {
      scrollToColumn: prevScrollToColumn,
      scrollToRow: prevScrollToRow
    } = this.props;

    if (prevScrollToColumn !== scrollToColumn && prevScrollToRow !== scrollToRow) {
      this.setState({
        scrollToColumn,
        scrollToRow
      });
    } else if (prevScrollToColumn !== scrollToColumn) {
      this.setState({
        scrollToColumn
      });
    } else if (prevScrollToRow !== scrollToRow) {
      this.setState({
        scrollToRow
      });
    }
  }

  setScrollIndexes({
    scrollToColumn,
    scrollToRow
  }) {
    this.setState({
      scrollToRow,
      scrollToColumn
    });
  }

  render() {
    const {
      className,
      children,
      style
    } = this.props;

    const {
      scrollToColumn,
      scrollToRow
    } = this._getScrollState();

    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      onKeyDown: this._onKeyDown,
      style: style
    }, children({
      onSectionRendered: this._onSectionRendered,
      scrollToColumn,
      scrollToRow,
      registerChild: this._registerChild
    }));
  }

}

exports.default = ArrowKeyStepper;
(0, _defineProperty2.default)(ArrowKeyStepper, "propTypes", {
  isControlled: _propTypes.default.bool,
  onScrollToChange: _propTypes.default.func,
  scrollToColumn: _propTypes.default.number,
  scrollToRow: _propTypes.default.number,
  className: _propTypes.default.string,
  children: _propTypes.default.func,
  columnCount: _propTypes.default.number,
  rowCount: _propTypes.default.number,
  fixedColumns: _propTypes.default.number,
  fixedRows: _propTypes.default.number,
  onFixedCornerCellMenu: _propTypes.default.func,
  onFixedRowCellMenu: _propTypes.default.func,
  style: _propTypes.default.object
});
(0, _defineProperty2.default)(ArrowKeyStepper, "defaultProps", {
  isControlled: false,
  scrollToColumn: 0,
  scrollToRow: 0,
  className: '',
  style: {}
});

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _GridResources = _interopRequireDefault(__webpack_require__(340));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_GridResources.default);

exports.default = _default;

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

var amdi18n={"__root":{"changeGridSettings":"Change grid settings","showSortHeader":"Show sort header","restore":"Restore","maximize":"Maximize"},"__cs":{"changeGridSettings":"Změnit nastavení mřížky","showSortHeader":"Zobrazit záhlaví řazení","restore":"Obnovit","maximize":"Maximalizovat"},"__da":{"changeGridSettings":"Revidér gitterindstillinger","showSortHeader":"Vis sorteringstoptekst","restore":"Gendan","maximize":"Maksimér"},"__de":{"changeGridSettings":"Rastereinstellungen ändern","showSortHeader":"Header für Sortierung anzeigen","restore":"Wiederherstellen","maximize":"Maximale Größe"},"__es":{"changeGridSettings":"Cambiar valores de cuadrícula","showSortHeader":"Mostrar cabecera de clasificación","restore":"Restaurar","maximize":"Maximizar"},"__fi":{"changeGridSettings":"Muuta ruudukon asetuksia","showSortHeader":"Näytä lajitteluotsikko","restore":"Palauta","maximize":"Suurenna"},"__fr":{"changeGridSettings":"Modifier les paramètres de grille","showSortHeader":"Afficher l'en-tête de tri","restore":"Restaurer","maximize":"Maximiser"},"__hr":{"changeGridSettings":"Promijeni postavke mreže","showSortHeader":"Pokaži zaglavlje sortiranja","restore":"Vrati","maximize":"Maksimiziraj"},"__hu":{"changeGridSettings":"Rácsbeállítások módosítása","showSortHeader":"Rendezési fejléc megjelenítése","restore":"Visszaállítás","maximize":"Maximális méret"},"__it":{"changeGridSettings":"Modifica impostazioni griglia","showSortHeader":"Mostra intestazione di ordinamento","restore":"Ripristino","maximize":"Rendi al massimo"},"__ja":{"changeGridSettings":"グリッド設定の変更","showSortHeader":"ソート・ヘッダーの表示","restore":"復元","maximize":"最大化"},"__kk":{"changeGridSettings":"Тор параметрлерін өзгерту","showSortHeader":"Сұрыптау тақырыбын көрсету","restore":"Қалпына келтіру","maximize":"Жаю"},"__ko":{"changeGridSettings":"눈금 설정 변경","showSortHeader":"정렬 헤더 표시","restore":"복원","maximize":"최대화"},"__nb":{"changeGridSettings":"Endre rutenettinnstillinger","showSortHeader":"Vis sorteringsoverskrift","restore":"Gjenopprett","maximize":"Maksimer"},"__nl":{"changeGridSettings":"Rasterinstellingen wijzigen","showSortHeader":"Sorteerheader afbeelden","restore":"Herstellen","maximize":"Maximaliseren"},"__no":{"changeGridSettings":"Endre rutenettinnstillinger","showSortHeader":"Vis sorteringsoverskrift","restore":"Gjenopprett","maximize":"Maksimer"},"__pl":{"changeGridSettings":"Zmień ustawienia siatki","showSortHeader":"Pokaż nagłówki do sortowania","restore":"Przywróć","maximize":"Maksymalizuj"},"__pt":{"changeGridSettings":"Mudar configurações da grade","showSortHeader":"Mostrar cabeçalho curto","restore":"Restaurar","maximize":"Maximizar"},"__pt-br":{"changeGridSettings":"Mudar configurações da grade","showSortHeader":"Mostrar cabeçalho curto","restore":"Restaurar","maximize":"Maximizar"},"__ro":{"changeGridSettings":"Modificare setări grilă","showSortHeader":"Afişare antet de sortare","restore":"Restaurare","maximize":"Maximizare"},"__ru":{"changeGridSettings":"Изменить параметры сетки","showSortHeader":"Показать заголовок сортировки","restore":"Восстановить","maximize":"Развернуть"},"__sl":{"changeGridSettings":"Spremeni nastavitve mreže","showSortHeader":"Pokaži glavo razvrščanja","restore":"Obnovi","maximize":"Maksimiraj"},"__sv":{"changeGridSettings":"Ändra rutnätsinställningar","showSortHeader":"Visa sorteringsrubrik","restore":"Återställ","maximize":"Maximera"},"__th":{"changeGridSettings":"เปลี่ยนการตั้งค่ากริด","showSortHeader":"แสดงการเรียงลำดับส่วนหัว","restore":"เรียกคืน","maximize":"ขยายให้มีขนาดใหญ่ที่สุด"},"__tr":{"changeGridSettings":"Izgara ayarlarını değiştir","showSortHeader":"Sıralama üstbilgisini göster","restore":"Geri Yükle","maximize":"Ekranı kapla"},"__zh":{"changeGridSettings":"更改网格设置","showSortHeader":"显示排序标题","restore":"复原","maximize":"最大化"},"__zh-cn":{"changeGridSettings":"更改网格设置","showSortHeader":"显示排序标题","restore":"复原","maximize":"最大化"},"__zh-hk":{"changeGridSettings":"變更網格設定","showSortHeader":"顯示排序標頭","restore":"還原","maximize":"最大化"},"__zh-mo":{"changeGridSettings":"變更網格設定","showSortHeader":"顯示排序標頭","restore":"還原","maximize":"最大化"},"__zh-sg":{"changeGridSettings":"更改网格设置","showSortHeader":"显示排序标题","restore":"复原","maximize":"最大化"},"__zh-tw":{"changeGridSettings":"變更網格設定","showSortHeader":"顯示排序標頭","restore":"還原","maximize":"最大化"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Grid_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(111);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Grid_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Grid_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Grid_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Grid_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[334,0]]]);
});